<template>
    <div class="left-vc-col">

        <div class="vc-col">
            <div class="vc-col-body">
                <strong>
                    Our valuation calculator captures the qualitative
                    aspects of your business using 4 different methods:
                </strong>
            </div>
        </div>

        <div class="vc-col">
            <div class="vc-col-title">
                Step Up Method:
            </div>
            <div class="vc-col-body">
                This method offers a structured way to use the accomplishment and external
                validations
                to
                develop a pre-money valuation.
            </div>
        </div>

        <div class="vc-col">
            <div class="vc-col-title">
                Risk Mitigation Method:
            </div>
            <div class="vc-col-body">
                This method assigns dollar values to the accomplishment and validations of the
                startup.
            </div>
        </div>

        <div class="vc-col">
            <div class="vc-col-title">
                Scorecard Method:
            </div>
            <div class="vc-col-body">
                This method compares the startup to other funded startups modifying the average
                valuation
                based on factors such as region, market, and stage.
            </div>
        </div>

        <div class="vc-col">
            <div class="vc-col-title">
                Checklist Method:
            </div>
            <div class="vc-col-body">
                The valuation of the startup consists of intangible building blocks that sum up to
                the
                assumed maximum pre-money valuation.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {},
    };
</script>
